import { useCallback, useEffect, useState } from "react";

const defaultQuery = {
  technologies: [],
  countries: [],
  statuses: [],
};

export default function useQuery(processQuery) {
  const [statuses, setStatuses] = useState(defaultQuery.statuses);
  const [technologies, setTechnologies] = useState(defaultQuery.technologies);
  const [countries, setCountries] = useState(defaultQuery.statuses);

  const setStatusHandler = useCallback((values) => {
    setStatuses(values);
  }, []);

  const setTechnologiesHandler = useCallback((values) => {
    setTechnologies(values);
  }, []);

  const setCountriesHandler = useCallback((values) => {
    setCountries(values);
  }, []);
  const resetSelection = useCallback(() => {
    setStatuses(defaultQuery.statuses);
    setTechnologies(defaultQuery.technologies);
    setCountries(defaultQuery.countries);
  }, []);

  useEffect(() => {
    processQuery({ statuses, technologies, countries });
  }, [statuses, technologies, countries, processQuery]);
  return {
    statuses,
    technologies,
    countries,
    setStatus: setStatusHandler,
    setTechnologies: setTechnologiesHandler,
    setCountries: setCountriesHandler,
    resetSelection,
  };
}
